// extracted by mini-css-extract-plugin
export default {"nav-buttons-wrapper":"NavButtons_nav-buttons-wrapper__GcTXu"};